module.exports = __webpack_public_path__ + "static/img/login_column_two03.e2494879.png";